import * as FPT from '../utility/fpt';
import $ from 'jquery';

function trackReportLink() {
  FPT.trackLinkClick('reportInappropriateContent');
}

export function addTrackReportLink() {
  $('.help_security').children()[2].addEventListener('click', trackReportLink);
}

export function removeTrackReportLink() {
  $('.help_security')
    .children()[2]
    .removeEventListener('click', trackReportLink);
}
